declare var $cookies: any;
import axios from 'axios';

axios.interceptors.request.use(function (config) {
    if ($cookies.isKey('userAuth')) {
        let userAuthStr = $cookies.get('userAuth');
        //let userAuthStr = 'BC06:1000:1545219369835:479f7c01ebb5ca6d4b173a7ffa3d6e31';
        
        config.headers = {
            'X-Auth-Token': userAuthStr,
            'CableNotes-Web': 'Yes'
        }
        //console.log('interceptors.request:' + config.headers + ' :: Token: ' + userAuthStr);
    } else {
        config.headers = {
            'CableNotes-Web': 'Yes'
        }
    }
    return config;
});